import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import DiariosExpoAnt from '../../../components/diario/listar/expomacuco';


function DiariosExpoAntScreen() {
    return (
        <Fragment>
            <Head titulo="Publicações da Expo Macuco em anos anteriores a 2023" />
            <Header />
            <Container>
                <DiariosExpoAnt />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default DiariosExpoAntScreen;